import React from "react";
import Router from "./Router";
import Globalstyle from "./static/style/Globalstyle";
import { RecoilRoot } from "recoil";
import { CookiesProvider } from "react-cookie";
import { HelmetProvider } from "react-helmet-async";
import { QueryClientProvider } from "@tanstack/react-query";
/* import { ReactQueryDevtools } from "@tanstack/react-query-devtools"; */
import { queryClient } from "./apis/utils";

import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      {/* <ReactQueryDevtools /> */}
      <RecoilRoot>
        <CookiesProvider>
          <HelmetProvider>
            <Globalstyle />
            <Router />
            <ToastContainer />
          </HelmetProvider>
        </CookiesProvider>
      </RecoilRoot>
    </QueryClientProvider>
  );
}

export default App;
